import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { action, IObservableValue, observable } from 'mobx';
import { globalConfig } from '../../../config/globalConfig';
import { OrganizationActions } from '../../Organization/actions/organizationActions';
import { OrganizationListParams } from '../../Organization/interfaces/organizationListParams';
import { OrganizationMin } from '../../Organization/models/organizationMin';
import { UserControllerActions } from '../../User/actions/userControllerActions';
import { UserListParams } from '../../User/interfaces/UserListParams';
import User from '../../User/models/user';

class TransactionOwnerStore {
    @observable users: IObservableValue<User[]>;
    @observable organizations: IObservableValue<OrganizationMin[]>;

    constructor() {
        this.users = observable.box<User[]>([]);
        this.organizations = observable.box<OrganizationMin[]>([]);
    }

    getOrganizationsByIds = (ids: string[]) => {
        if (!ids.length) return;

        let organizationIdsAreNotInStore: string[] = [];

        organizationIdsAreNotInStore = ids.reduce(
            (accum: string[] | null[], id) => {
                const value = !this.getOrganizationById(id) && !organizationIdsAreNotInStore.includes(id)
                    ? id
                    : null;

                return accum.concat(value)
            },
            [],
        )
            .filter(it => !!it) as string[];

        if (!organizationIdsAreNotInStore.length) return;

        let queryParams: OrganizationListParams = {
            ids: organizationIdsAreNotInStore,
        };

        OrganizationActions.list(queryParams)
            .then((organizations: OrganizationMin[]) => this.setOrganizations(organizations))
    };

    @action('set organization')
    setOrganizations = (organizations: OrganizationMin[]) => {
        this.organizations.set([...this.getOrganizations(), ...organizations]);
    }

    getOrganizations = (): OrganizationMin[] => {
        return this.organizations.get();
    }

    getOrganizationById = (id: string) => {
        let organizations: OrganizationMin[] = this.getOrganizations();
        let index: number = organizations.findIndex(
            (organization: OrganizationMin) => organization.id === id,
        );

        return organizations[index];
    }

    getUsersByIds = (ids: string[]) => {
        if (!ids.length) return;

        let userIdsAreNotInStore: string[] = [];
        ids.forEach((id) => {
            if (!this.getUserById(id) && !userIdsAreNotInStore.includes(id)) {
                userIdsAreNotInStore.push(id);
            }
        });

        if (!userIdsAreNotInStore.length) return;

        let queryParams: UserListParams = {
            ids: userIdsAreNotInStore,
            pageNo: 0,
            pageSize: globalConfig.maxPageSize,
        };

        UserControllerActions.list(queryParams)
            .then((collectionUsers: CollectionDTOInterface<User>) => this.setUsers(collectionUsers.items))
    };

    @action('set users')
    setUsers = (users: User[]) => {
        this.users.set([...this.getUsers(), ...users]);
    }

    getUsers = (): User[] => {
        return this.users.get();
    }

    getUserById = (id: string) => {
        let users: User[] = this.getUsers();
        let index: number = users.findIndex((user: User) => user.id === id);

        return users[index];
    }

    getUserPersonalityById = (id: string) => {
        const user: User = this.getUserById(id);

        if (!user) return 'Анонимный пользователь';

        const personality = user.profile?.personality;
        return personality ? `${personality.lastName ?? ''} ${personality.firstName ?? ''} ${personality.middleName ?? ''}` : 'Анонимный пользователь';
    }
}

const transactionOwnerStore = new TransactionOwnerStore();

export default transactionOwnerStore;
export { TransactionOwnerStore };
